import { render, staticRenderFns } from "./LevelSelector.vue?vue&type=template&id=d2ea7962&scoped=true&"
import script from "./LevelSelector.vue?vue&type=script&lang=js&"
export * from "./LevelSelector.vue?vue&type=script&lang=js&"
import style0 from "./LevelSelector.vue?vue&type=style&index=0&id=d2ea7962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ea7962",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
